(function () {
    window.lastScrollYPosition = 0;

    var hamburger = document.getElementById("hamburger"),
        mainNav = document.getElementById("main-nav"),
        search = document.getElementById("search"),
        homeBody = document.getElementById("home-body"),
        animation = document.getElementById("animation"),
        loader = document.getElementsByClassName("animated-loader")[0],
        postSidebar = document.getElementById("post-sidebar"),
        tooltips = document.querySelectorAll("[data-title]"),
        videoModalOpen = document.getElementById("video-modal-open"),
        videoPreview = document.getElementById("video-preview"),
        videoModal = document.getElementById("video-modal"),
        videoModalClose = document.getElementById("video-modal-close"),
        videoModalVideo = document.getElementById("video-modal-video"),
        header = document.getElementById("header"),
        headerSearch = document.querySelector(".header__nav-search-wrap"),
        chamberEvents = document.getElementById("chamber-events"),
        mainMenuNav = document.getElementById("menu-main-navigation"),
        econoDevWrap = document.querySelector(".header__economic-dev-nav-wrap"),
        bioButtons = document.getElementsByClassName("staff__bio-button"),
        headerAcct = document.querySelector('.header__profile-img-wrap'),
        headerReportBuilder = document.querySelector('.header__report-builder-wrap'),
        headerSlideArrow = document.querySelector('.header__body-slide-arrow'),
        popupwrap = document.querySelector('.gws-popup__wrap'),
        popupContainer = document.querySelector('.gws-popup__container'),
        popupCTA = document.querySelector('.gws-popup-close__wrap'),
        hamburgerOpenClass = "header__hamburger--open",
        mainNavClosedClass = "header__nav-wrap--closed",
        mainNavSearchOpenClass = "header__nav-wrap--search-open",
        subNavOpenClass = "header__sub-nav--open",
        searchInputOpenClass = "header__search-input--open",
        openSubNav = null,
        selectedMainMenuItem = null,
        econoNavOpened = false,
        subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;

    Array.from(document.getElementsByTagName('a')).forEach(function(item) {
        var href = item.getAttribute('href');

        if (href && href.includes('http')) {
            item.addEventListener('click', sendEvent_linkClick);
        }
    });

    document.addEventListener("click", navHandler);
    document.addEventListener("mouseover", navHandler);
    document.addEventListener("click", function (evt) {
        if (evt.target !== search && evt.target !== hamburgerOpenClass) {
            search.classList.remove(searchInputOpenClass);
            mainNav.classList.remove(mainNavSearchOpenClass);
        } else {
            search.classList.add(searchInputOpenClass);
            mainNav.classList.add(mainNavSearchOpenClass);
        }
    });

    if (subdomain && subdomain === 'web') {
        headerSearch.style.display = 'none';
    }

    if (document.body.classList.contains('blue-page')) {
        window.addEventListener("scroll", throttle(stickyHeaderFrontpage, 100));
    } else {
        window.addEventListener("scroll", throttle(stickyHeader, 100));
    }

    if (videoModalOpen) {
        videoModalOpen.addEventListener("click", openVid);
        videoModalClose.addEventListener("click", closeVid);
        document.addEventListener("keyup", function (e) {
            if (e.key === "Escape") {
                closeVid();
            }
        });
    }

    if (popupCTA) {
        popupCTA.addEventListener("click", (e) => {
            popupContainer.classList.add("gws-popup__container--hidden");
            popupwrap.classList.add("gws-popup__wrap--hidden");
            document.body.classList.remove('BodyFreeze');
        });
    }

    if (animation) {
        window.addEventListener("scroll", function () {
            if (animation.played.length === 0) {
                if (window.innerHeight + window.scrollY >= homeBody.offsetHeight) {
                    animation.play();
                } else {
                    animation.pause();
                }
            }
        });
    }

    if (hamburger) {
        var navOpenClass = "header__body-wrap--open";
        hamburger.addEventListener("click", function () {
            if (hamburger.classList.contains(hamburgerOpenClass)) {
                hamburger.classList.remove(hamburgerOpenClass);
                mainNav.classList.add(mainNavClosedClass);
                header.classList.remove(navOpenClass);
                document.body.style.overflow = "auto";
                headerAcct.style.display = "block";
                headerReportBuilder.style.display = "block";
            } else {
                hamburger.classList.add(hamburgerOpenClass);
                mainNav.classList.remove(mainNavClosedClass);
                header.classList.add(navOpenClass);
                document.body.style.overflow = "hidden";
                headerAcct.style.display = "none";
                headerReportBuilder.style.display = "none";
            }
        });
    }

    if (loader) {
        window.addEventListener("load", function () {
            loader.classList.add("wscc-animated-loader--hidden");

            if (popupwrap) {
                popupwrap.classList.remove("gws-popup__wrap--hidden");
                popupContainer.classList.remove("gws-popup__container--hidden");
                document.body.classList.add('BodyFreeze');
            }

            setTimeout(function () {
                window.scrollTo(0, 0);
            });
        });
    }

    if (postSidebar) {
        if (document.body.scrollHeight > window.innerHeight) {
            postSidebar.classList.add("wscc-sidebar--fixed");

            window.addEventListener("scroll", throttle(function () {
                var footer = document.querySelector('body > footer'),
                    mainContent = document.getElementsByClassName('wscc-main-content__body')[0],
                    marginTop = parseFloat(window.getComputedStyle(postSidebar).marginTop),
                    bottomOfSidebar = window.pageYOffset + postSidebar.offsetTop + postSidebar.offsetHeight + marginTop,
                    bottomOfContent = mainContent.offsetTop + mainContent.offsetHeight;

                if (!window.pageYOffsetAtPause) {
                    if (bottomOfSidebar > bottomOfContent) {
                        postSidebar.classList.add("pause");
                        window.pageYOffsetAtPause = window.pageYOffset;
                    }
                } else if (window.pageYOffset < window.pageYOffsetAtPause) {
                    postSidebar.classList.remove("pause");
                    delete window.pageYOffsetAtPause;
                }
            }, 20));
        }
    }

    if (chamberEvents) {
        window.addEventListener("load", function () {
            chamberEvents.querySelectorAll(".MembeeEvent").forEach(function (eventNode) {
                var link = eventNode.querySelector(".MembeeEventLink .MembeeEventLink_text");
                var title = link.innerHTML;
                link.innerHTML = "View Event";
                var titleElem = document.createElement("h3");
                titleElem.innerHTML = title;
                titleElem.classList.add("MembeeTitle");
                eventNode.appendChild(titleElem);
            });
        });
    }

    if (search) {
        search.addEventListener("click", function () {
            if (search.classList.contains(searchInputOpenClass)) {
                search.classList.remove(searchInputOpenClass);
                mainNav.classList.remove(mainNavSearchOpenClass);
            } else {
                search.classList.add(searchInputOpenClass);
                mainNav.classList.add(mainNavSearchOpenClass);
            }
        });
    }

    if (bioButtons.length) {
        var bioOpenClass = "staff__bio--open";
        Array.prototype.forEach.call(bioButtons, function (btn) {
            btn.addEventListener("click", function () {
                var bio = btn.parentNode.querySelector(".staff__bio");
                var bioArrow = btn.parentNode.querySelector(".staff__bio-arrow");

                if (bio.classList.contains(bioOpenClass)) {
                    bio.classList.remove(bioOpenClass);
                    bioArrow.style.transform = "rotate(90deg)";
                } else {
                    bio.classList.add(bioOpenClass);
                    bioArrow.style.transform = "rotate(-90deg)";
                }
            });
        });
    }

    // if (mainMenuNav) {
    //     var mainMenuNavItems = mainMenuNav.children;
    //     Array.prototype.forEach.call(mainMenuNavItems, function (navItem) {
    //         navItem.children[0].addEventListener("click", function (evt) {
    //             selectedMainMenuItem = navItem.children[0];
    //             if (navItem.classList.contains('menu-item--economic-development')) {
    //                 evt.preventDefault();
    //                 econoDevWrap.classList.toggle('header__sub-nav-wrap--closed');
    //                 navItem.children[0].classList.add('sub-menu--active');
    //                 econoNavOpened = true;
    //             }
    //             headerSlideArrow.classList.toggle('header__body-slide-hide');
    //             document.querySelector('.header__nav-overlay').classList.toggle('header__nav-overlay--hide');
    //         });
    //     });
    // }

    // if (headerSlideArrow) {
    //     let subnavCloseButtons = [headerSlideArrow, document.querySelector('.header__nav-overlay')];
    //     Array.prototype.forEach.call(subnavCloseButtons, function (button) {
    //         button.addEventListener("click", function (evt) {
    //             selectedMainMenuItem.click();
    //             if (econoNavOpened) {
    //                 var ecoDevNavLink = document.querySelector(".menu-item--economic-development").children[0];
    //                 if (ecoDevNavLink) {
    //                     ecoDevNavLink.classList.remove("sub-menu--active");
    //                     econoNavOpened = false;
    //                 }
    //             }
    //         });
    //     });
    // }

    if (tooltips) {
        for (let i = 0; i < tooltips.length; i++) {
            tooltips[i].onmouseover = tooltip;
            tooltips[i].onmouseout = tooltipDestroy;
        }
    }

    function didNotClick(query, func) {
        return function () {
            var context = this, args = arguments, target = event.target;
            while (target) {
                if (target == query) {
                    return false;
                } else {
                    target = target.parentElement;
                }
            }
            func.apply(context, args);
        };
    };

    function navHandler(evt) {
        var subMenuActiveClass = "sub-menu--active";
        if (evt.type === "mouseover" && !mainNav.classList.contains(mainNavClosedClass)) {
            return;
        }
        if (evt.target.nodeName === "A" && evt.target.parentNode.classList.contains("menu-item")) {
            var subNav = evt.target.parentNode.querySelector(".sub-menu");
            var activeMainNav = evt.target.parentNode.firstChild;

            var isSubSubNav = subNav?.parentNode?.parentNode?.classList?.contains('sub-menu');

            if (subNav) {
                evt.preventDefault();

                if (openSubNav && openSubNav !== subNav) {
                    if (!isSubSubNav) {
                        openSubNav.classList.remove(subNavOpenClass);
                        openSubNav.parentNode.firstChild.classList.remove(subMenuActiveClass);
                    } else {
                        let sibling = subNav.parentNode.parentNode.firstChild;

                        while (sibling) {
                            if (sibling.nodeType === 1 && sibling !== subNav.parentNode) {
                                sibling.children[0].classList.remove(subMenuActiveClass);

                                if (sibling.children[1]) {
                                    sibling.children[1].classList.remove(subNavOpenClass);
                                }
                            }

                            sibling = sibling.nextSibling;
                        }
                    }
                }

                var action;
                if (evt.type === "click") {
                    action = "toggle";
                } else {
                    action = "add";
                }

                subNav.classList[action](subNavOpenClass);
                activeMainNav.classList[action](subMenuActiveClass);

                openSubNav = subNav;
            }
        } else if (openSubNav && !header.contains(evt.target)) {
            openSubNav.classList.remove(subNavOpenClass);
            openSubNav.parentNode.firstChild.classList.remove(subMenuActiveClass);
        }
    }

    function openVid() {
        videoPreview.pause();
        videoModal.style.display = "";
        document.body.style.overflow = "hidden";
        videoModalVideo.play();
    }

    function closeVid() {
        videoPreview.play();
        document.body.style.overflow = "";
        videoModal.style.display = "none";
        videoModalVideo.pause();
        videoModalVideo.currentTime = 0;
    }

    function sendEvent_linkClick(event) {
        var url = document.createElement('a');
        url.href = event.target.getAttribute('href');

        if (url.host != location.host) {
            gtag('event', 'link_click', {'outbound_link_url': url.href});
            console.log('gtag initiated');
        }
    }

    function stickyHeader() {
        if (loader.classList.contains("wscc-animated-loader--hidden")
            && mainNav.classList.contains('header__nav-wrap--closed')) {

            if (pageYOffset == 0) {
                header.classList.remove('shadow');
            } else {
                header.classList.add('shadow');
            }

            if (pageYOffset > header.offsetHeight) {
                if (pageYOffset - lastScrollYPosition > 0) {
                    header.classList.add('hide');
                } else {
                    header.classList.remove('hide');
                }
            } else {
                header.classList.remove('hide');
            }

            window.lastScrollYPosition = Math.abs(pageYOffset);
        }
    }

    function stickyHeaderFrontpage() {
        if (loader.classList.contains("wscc-animated-loader--hidden")
            && mainNav.classList.contains('header__nav-wrap--closed')) {
            var profileBlue = document.querySelector('.header__profile-img--blue'),
                profileWhite = document.querySelector('.header__profile-img--white'),
                reportBlue = document.querySelector('.header__report-builder-img--blue'),
                reportWhite = document.querySelector('.header__report-builder-img--white'),
                logo = document.querySelector('.header__logo');

            if (pageYOffset == 0) {
                header.classList.remove('shadow');
            } else {
                header.classList.add('shadow');
            }

            // if (pageYOffset > videoPreview.offsetHeight - header.offsetHeight) {
            if (pageYOffset > header.offsetHeight) {
                if (pageYOffset - lastScrollYPosition > 0) {
                    header.classList.add('hide');

                    setTimeout(function () {
                        header.classList.remove('darkonwhite');

                        profileBlue.style.display = 'none';
                        profileWhite.style.display = 'inline';
                        reportBlue.style.display = 'none';
                        reportWhite.style.display = 'inline';
                    }, 150);
                } else {
                    header.classList.add('darkonwhite');

                    profileWhite.style.display = 'none';
                    profileBlue.style.display = 'inline';
                    reportWhite.style.display = 'none';
                    reportBlue.style.display = 'inline';

                    header.classList.remove('hide');
                }
            } else {
                header.classList.remove('darkonwhite');

                profileBlue.style.display = 'none';
                profileWhite.style.display = 'inline';
                reportBlue.style.display = 'none';
                reportWhite.style.display = 'inline';

                header.classList.remove('hide');
            }
            window.lastScrollYPosition = Math.abs(pageYOffset);
        }
    }

    function throttle(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    function tooltip() {
        if (!this.children[0].classList.contains('header__hamburger--open')) {
            const div = document.createElement('div');
            const id = 'tooltip-' + this.dataset.title.replace(' ', '').toLowerCase();

            div.className = 'tooltip';
            div.id = id;
            div.innerHTML = this.dataset.title;

            this.appendChild(div);
        }
    }

    function tooltipDestroy() {
        const tips = document.getElementsByClassName('tooltip');

        for (let i = 0; i < tips.length; i++) {
            tips[i].remove();
        }

        this.removeEventListener('onmouseout', tooltipDestroy);
    }

    new Swiper('.swiper-container', {
        effect: "fade",
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
})();

(function () {
    if (location.hostname == 'web.winstonsalem.com') {
        document.querySelector('a[href="/news"]').href = 'https://www.winstonsalem.com/news';
    }
})();
